import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/_hooks.js'), '_hooks.js')
  resolveStoreModules(require('../store/messages/actions.js'), 'messages/actions.js')
  resolveStoreModules(require('../store/messages/mutations.js'), 'messages/mutations.js')
  resolveStoreModules(require('../store/messages/state.js'), 'messages/state.js')
  resolveStoreModules(require('../store/_core/_hooks/index.js'), '_core/_hooks/index.js')
  resolveStoreModules(require('../store/_core/application/actions.js'), '_core/application/actions.js')
  resolveStoreModules(require('../store/_core/application/getters.js'), '_core/application/getters.js')
  resolveStoreModules(require('../store/_core/application/mutations.js'), '_core/application/mutations.js')
  resolveStoreModules(require('../store/_core/application/state.js'), '_core/application/state.js')
  resolveStoreModules(require('../store/_core/applicationStatus/actions.js'), '_core/applicationStatus/actions.js')
  resolveStoreModules(require('../store/_core/applicationStatus/getters.js'), '_core/applicationStatus/getters.js')
  resolveStoreModules(require('../store/_core/auth/actions.js'), '_core/auth/actions.js')
  resolveStoreModules(require('../store/_core/auth/getters.js'), '_core/auth/getters.js')
  resolveStoreModules(require('../store/_core/auth/mutations.js'), '_core/auth/mutations.js')
  resolveStoreModules(require('../store/_core/auth/state.js'), '_core/auth/state.js')
  resolveStoreModules(require('../store/_core/featureSettings/actions.js'), '_core/featureSettings/actions.js')
  resolveStoreModules(require('../store/_core/featureSettings/getters.js'), '_core/featureSettings/getters.js')
  resolveStoreModules(require('../store/_core/featureSettings/mutations.js'), '_core/featureSettings/mutations.js')
  resolveStoreModules(require('../store/_core/featureSettings/state.js'), '_core/featureSettings/state.js')
  resolveStoreModules(require('../store/_core/header/mutations.js'), '_core/header/mutations.js')
  resolveStoreModules(require('../store/_core/header/state.js'), '_core/header/state.js')
  resolveStoreModules(require('../store/_core/locales/mutations.js'), '_core/locales/mutations.js')
  resolveStoreModules(require('../store/_core/locales/state.js'), '_core/locales/state.js')
  resolveStoreModules(require('../store/_core/navigation/state.js'), '_core/navigation/state.js')
  resolveStoreModules(require('../store/_core/notification/actions.js'), '_core/notification/actions.js')
  resolveStoreModules(require('../store/_core/notification/getters.js'), '_core/notification/getters.js')
  resolveStoreModules(require('../store/_core/notification/mutations.js'), '_core/notification/mutations.js')
  resolveStoreModules(require('../store/_core/notification/state.js'), '_core/notification/state.js')
  resolveStoreModules(require('../store/_core/supportSettings/actions.js'), '_core/supportSettings/actions.js')
  resolveStoreModules(require('../store/_core/supportSettings/getters.js'), '_core/supportSettings/getters.js')
  resolveStoreModules(require('../store/_core/supportSettings/mutations.js'), '_core/supportSettings/mutations.js')
  resolveStoreModules(require('../store/_core/supportSettings/state.js'), '_core/supportSettings/state.js')
  resolveStoreModules(require('../store/_core/tenant/actions.js'), '_core/tenant/actions.js')
  resolveStoreModules(require('../store/_core/tenant/getters.js'), '_core/tenant/getters.js')
  resolveStoreModules(require('../store/_core/tenant/mutations.js'), '_core/tenant/mutations.js')
  resolveStoreModules(require('../store/_core/tenant/state.js'), '_core/tenant/state.js')
  resolveStoreModules(require('../store/_core/toastNotifications/actions.js'), '_core/toastNotifications/actions.js')
  resolveStoreModules(require('../store/_core/toastNotifications/mutations.js'), '_core/toastNotifications/mutations.js')
  resolveStoreModules(require('../store/_core/toastNotifications/state.js'), '_core/toastNotifications/state.js')
  resolveStoreModules(require('../store/_core/user/actions.js'), '_core/user/actions.js')
  resolveStoreModules(require('../store/_core/user/getters.js'), '_core/user/getters.js')
  resolveStoreModules(require('../store/_core/user/mutations.js'), '_core/user/mutations.js')
  resolveStoreModules(require('../store/_core/user/state.js'), '_core/user/state.js')
  resolveStoreModules(require('../store/plataforma/calendar/actions.js'), 'plataforma/calendar/actions.js')
  resolveStoreModules(require('../store/plataforma/calendar/getters.js'), 'plataforma/calendar/getters.js')
  resolveStoreModules(require('../store/plataforma/calendar/mutations.js'), 'plataforma/calendar/mutations.js')
  resolveStoreModules(require('../store/plataforma/calendar/state.js'), 'plataforma/calendar/state.js')
  resolveStoreModules(require('../store/plataforma/categories/actions.js'), 'plataforma/categories/actions.js')
  resolveStoreModules(require('../store/plataforma/categories/getters.js'), 'plataforma/categories/getters.js')
  resolveStoreModules(require('../store/plataforma/categories/mutations.js'), 'plataforma/categories/mutations.js')
  resolveStoreModules(require('../store/plataforma/categories/state.js'), 'plataforma/categories/state.js')
  resolveStoreModules(require('../store/plataforma/content/actions.js'), 'plataforma/content/actions.js')
  resolveStoreModules(require('../store/plataforma/content/getters.js'), 'plataforma/content/getters.js')
  resolveStoreModules(require('../store/plataforma/content/mutations.js'), 'plataforma/content/mutations.js')
  resolveStoreModules(require('../store/plataforma/content/state.js'), 'plataforma/content/state.js')
  resolveStoreModules(require('../store/plataforma/courses/actions.js'), 'plataforma/courses/actions.js')
  resolveStoreModules(require('../store/plataforma/courses/getters.js'), 'plataforma/courses/getters.js')
  resolveStoreModules(require('../store/plataforma/courses/mutations.js'), 'plataforma/courses/mutations.js')
  resolveStoreModules(require('../store/plataforma/courses/state.js'), 'plataforma/courses/state.js')
  resolveStoreModules(require('../store/plataforma/dashboard/mutations.js'), 'plataforma/dashboard/mutations.js')
  resolveStoreModules(require('../store/plataforma/dashboard/state.js'), 'plataforma/dashboard/state.js')
  resolveStoreModules(require('../store/plataforma/enrollment/actions.js'), 'plataforma/enrollment/actions.js')
  resolveStoreModules(require('../store/plataforma/enrollment/getters.js'), 'plataforma/enrollment/getters.js')
  resolveStoreModules(require('../store/plataforma/enrollment/mutations.js'), 'plataforma/enrollment/mutations.js')
  resolveStoreModules(require('../store/plataforma/enrollment/state.js'), 'plataforma/enrollment/state.js')
  resolveStoreModules(require('../store/plataforma/formulas/actions.js'), 'plataforma/formulas/actions.js')
  resolveStoreModules(require('../store/plataforma/formulas/getters.js'), 'plataforma/formulas/getters.js')
  resolveStoreModules(require('../store/plataforma/formulas/mutations.js'), 'plataforma/formulas/mutations.js')
  resolveStoreModules(require('../store/plataforma/formulas/state.js'), 'plataforma/formulas/state.js')
  resolveStoreModules(require('../store/plataforma/functions/actions.js'), 'plataforma/functions/actions.js')
  resolveStoreModules(require('../store/plataforma/grades/actions.js'), 'plataforma/grades/actions.js')
  resolveStoreModules(require('../store/plataforma/grades/getters.js'), 'plataforma/grades/getters.js')
  resolveStoreModules(require('../store/plataforma/grades/mutations.js'), 'plataforma/grades/mutations.js')
  resolveStoreModules(require('../store/plataforma/grades/state.js'), 'plataforma/grades/state.js')
  resolveStoreModules(require('../store/plataforma/groups/actions.js'), 'plataforma/groups/actions.js')
  resolveStoreModules(require('../store/plataforma/groups/getters.js'), 'plataforma/groups/getters.js')
  resolveStoreModules(require('../store/plataforma/groups/mutations.js'), 'plataforma/groups/mutations.js')
  resolveStoreModules(require('../store/plataforma/groups/state.js'), 'plataforma/groups/state.js')
  resolveStoreModules(require('../store/plataforma/groupsets/actions.js'), 'plataforma/groupsets/actions.js')
  resolveStoreModules(require('../store/plataforma/institutionConfiguration/actions.js'), 'plataforma/institutionConfiguration/actions.js')
  resolveStoreModules(require('../store/plataforma/institutionConfiguration/getters.js'), 'plataforma/institutionConfiguration/getters.js')
  resolveStoreModules(require('../store/plataforma/institutionConfiguration/mutations.js'), 'plataforma/institutionConfiguration/mutations.js')
  resolveStoreModules(require('../store/plataforma/institutionConfiguration/state.js'), 'plataforma/institutionConfiguration/state.js')
  resolveStoreModules(require('../store/plataforma/language/actions.js'), 'plataforma/language/actions.js')
  resolveStoreModules(require('../store/plataforma/language/getters.js'), 'plataforma/language/getters.js')
  resolveStoreModules(require('../store/plataforma/language/mutations.js'), 'plataforma/language/mutations.js')
  resolveStoreModules(require('../store/plataforma/language/state.js'), 'plataforma/language/state.js')
  resolveStoreModules(require('../store/plataforma/locality/actions.js'), 'plataforma/locality/actions.js')
  resolveStoreModules(require('../store/plataforma/logs/actions.js'), 'plataforma/logs/actions.js')
  resolveStoreModules(require('../store/plataforma/ltiLauncher/actions.js'), 'plataforma/ltiLauncher/actions.js')
  resolveStoreModules(require('../store/plataforma/ltiLinks/actions.js'), 'plataforma/ltiLinks/actions.js')
  resolveStoreModules(require('../store/plataforma/ltiProviders/actions.js'), 'plataforma/ltiProviders/actions.js')
  resolveStoreModules(require('../store/plataforma/ltiTools/actions.js'), 'plataforma/ltiTools/actions.js')
  resolveStoreModules(require('../store/plataforma/messages/actions.js'), 'plataforma/messages/actions.js')
  resolveStoreModules(require('../store/plataforma/newContent/actions.js'), 'plataforma/newContent/actions.js')
  resolveStoreModules(require('../store/plataforma/newContent/getters.js'), 'plataforma/newContent/getters.js')
  resolveStoreModules(require('../store/plataforma/newContent/mutations.js'), 'plataforma/newContent/mutations.js')
  resolveStoreModules(require('../store/plataforma/newContent/state.js'), 'plataforma/newContent/state.js')
  resolveStoreModules(require('../store/plataforma/notice/actions.js'), 'plataforma/notice/actions.js')
  resolveStoreModules(require('../store/plataforma/notice/mutations.js'), 'plataforma/notice/mutations.js')
  resolveStoreModules(require('../store/plataforma/notice/state.js'), 'plataforma/notice/state.js')
  resolveStoreModules(require('../store/plataforma/noticesBoard/actions.js'), 'plataforma/noticesBoard/actions.js')
  resolveStoreModules(require('../store/plataforma/noticesBoard/getters.js'), 'plataforma/noticesBoard/getters.js')
  resolveStoreModules(require('../store/plataforma/noticesBoard/mutations.js'), 'plataforma/noticesBoard/mutations.js')
  resolveStoreModules(require('../store/plataforma/noticesBoard/state.js'), 'plataforma/noticesBoard/state.js')
  resolveStoreModules(require('../store/plataforma/periods/actions.js'), 'plataforma/periods/actions.js')
  resolveStoreModules(require('../store/plataforma/periods/getters.js'), 'plataforma/periods/getters.js')
  resolveStoreModules(require('../store/plataforma/periods/mutations.js'), 'plataforma/periods/mutations.js')
  resolveStoreModules(require('../store/plataforma/periods/state.js'), 'plataforma/periods/state.js')
  resolveStoreModules(require('../store/plataforma/permissions/actions.js'), 'plataforma/permissions/actions.js')
  resolveStoreModules(require('../store/plataforma/permissions/mutations.js'), 'plataforma/permissions/mutations.js')
  resolveStoreModules(require('../store/plataforma/permissions/state.js'), 'plataforma/permissions/state.js')
  resolveStoreModules(require('../store/plataforma/roles/actions.js'), 'plataforma/roles/actions.js')
  resolveStoreModules(require('../store/plataforma/roles/getters.js'), 'plataforma/roles/getters.js')
  resolveStoreModules(require('../store/plataforma/roles/mutations.js'), 'plataforma/roles/mutations.js')
  resolveStoreModules(require('../store/plataforma/roles/state.js'), 'plataforma/roles/state.js')
  resolveStoreModules(require('../store/plataforma/rubrics/actions.js'), 'plataforma/rubrics/actions.js')
  resolveStoreModules(require('../store/plataforma/snackbar/mutations.js'), 'plataforma/snackbar/mutations.js')
  resolveStoreModules(require('../store/plataforma/snackbar/state.js'), 'plataforma/snackbar/state.js')
  resolveStoreModules(require('../store/plataforma/tags/actions.js'), 'plataforma/tags/actions.js')
  resolveStoreModules(require('../store/plataforma/terms/actions.js'), 'plataforma/terms/actions.js')
  resolveStoreModules(require('../store/plataforma/terms/getters.js'), 'plataforma/terms/getters.js')
  resolveStoreModules(require('../store/plataforma/terms/mutations.js'), 'plataforma/terms/mutations.js')
  resolveStoreModules(require('../store/plataforma/terms/state.js'), 'plataforma/terms/state.js')
  resolveStoreModules(require('../store/plataforma/upload/actions.js'), 'plataforma/upload/actions.js')
  resolveStoreModules(require('../store/plataforma/user/actions.js'), 'plataforma/user/actions.js')
  resolveStoreModules(require('../store/plataforma/user/getters.js'), 'plataforma/user/getters.js')
  resolveStoreModules(require('../store/plataforma/user/mutations.js'), 'plataforma/user/mutations.js')
  resolveStoreModules(require('../store/plataforma/user/state.js'), 'plataforma/user/state.js')
  resolveStoreModules(require('../store/plataforma/users/actions.js'), 'plataforma/users/actions.js')
  resolveStoreModules(require('../store/plataforma/zendesk/actions.js'), 'plataforma/zendesk/actions.js')
  resolveStoreModules(require('../store/plataforma/zendesk/getters.js'), 'plataforma/zendesk/getters.js')
  resolveStoreModules(require('../store/plataforma/zendesk/mutations.js'), 'plataforma/zendesk/mutations.js')
  resolveStoreModules(require('../store/plataforma/zendesk/state.js'), 'plataforma/zendesk/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
